import Iconify from 'src/components/iconify/iconify';

interface ICasBooleanIcon {
  value: boolean;
  falseIcon: boolean;
  size?: number;
}

export default function CasBooleanIcon({ value, falseIcon, size= 20 }: ICasBooleanIcon) {
  if (value) return <Iconify icon="icon-park-solid:correct" width={size} color="#808080" />;
  if (falseIcon && value === false)
    return <Iconify icon="mdi:close-thick" width={size} color="error.main" />;
  return null
}
